import FrameworkCourseController from "../../../framework-course.controller";

class Diagram3Controller extends FrameworkCourseController {

  constructor(courseService, diagramService, $translate, $timeout, $scope) {
    'ngInject';
    super(courseService, diagramService, $translate, $timeout, $scope);
    this.isFiveSection = true
    this.amountCorrectAnswers = 4;
    this.exerciseId = 'exercise-2';
    this.clearDiagramId = 2
    this.pyramidData = {
      exerciseNumber: 2,
      scheme: {
        model: {
          textarea: 'We should think seriously about negotating to develop an outsourcing relationship',
        },
        children: [
          {
            model: {
              textarea: 'Upgrading will not address the present system\'s deficiencies',
            },
            children: [

            ]
          },
          {
            model: {
              textarea: 'Migrating to a new system would be high cost, without solving all of the problems',
            },
            children: [

            ]
          },
          {
            model: {
              textarea: 'Outsourcing provides a better product at a cost much lower than the present $12m',
            },
            children: [

            ]
          },
          {
            model: {
              textarea: 'Two highly rated vendors are avaible to do the job',
            },
            children: [

            ]
          },
        ],
      },
      instruction: `<p>You are now ready to determine the appropriate Situation, Complication, and Question for the pyramid below. I have indicated the areas in the problem definition from which the information for each part of the introduction can be found.</p>
                    <ol>
                     <li>Situation = Sit</li>
                     <li>Disturbing Event = DE</li>
                     <li>Result 1 = R1</li>
                     <li>Result 2 = R2</li>
                     <li>Solution = Sol</li>
                    </ol>
                    <p>What you want to do now is make a 1 or 2 sentence summary of the essence of what it will say. Once you have done that and pressed Complete, you can take a look at the full introduction I would have written.</p>`,
      scq: {
        's-header': 'Sit, DE, R1, R2',
        'c-header': 'Sol'
      },
      additionalBox: 'Believe we should nevertheless think seriously about negotiating to develop an outsourcing relationship',
      opacity: 0.5,
    };
  }
}

export default Diagram3Controller;



// WEBPACK FOOTER //
// ./client/app/components/diagrams/5/5b/diagram3/diagram3.controller.js